import * as Yup from "yup";
import { PhoneNumberUtil } from "google-libphonenumber";
import { strictEmailRegex } from "@me-team/host/src/utils/utils";
import { TFunction } from "i18next";

const phoneUtil = PhoneNumberUtil.getInstance();

const isPhoneValid = (phone: string) => {
    try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
    } catch {
        return false;
    }
};

export const foodBusinessFormValidationSchema = (t: TFunction) => {
    return Yup.object().shape({
        name: Yup.string()
            .max(50, t("Max length is", { number: 50 }))
            .required(t("Name is required")),
        country: Yup.number().required(t("Country is required")),
        city: Yup.number()
            .nullable()
            .test("city-required-if-no-customCity", t("City is required"), function (value) {
                const { customCity } = this.parent;
                return customCity ? true : value !== null && value !== undefined;
            })
            .test("customCity-error-location", "", function (value) {
                const { customCity } = this.parent;
                if (!customCity && (value === null || value === undefined)) {
                    return this.createError({
                        path: "customCity",
                        message: t("Custom city name is required"),
                    });
                }
                return true;
            }),
        customCity: Yup.string()
            .nullable()
            .test("customCity-required-if-no-city", t("Custom city name is required"), function (value) {
                const { city } = this.parent;
                return city !== -1 ? true : value !== null && value !== undefined && value !== "";
            }),
        address: Yup.string().required(t("Address is required")),
        phone: Yup.string()
            .required(t("Phone number is required"))
            .test("is-valid-phone", t("Phone number is not valid"), (value) => isPhoneValid(value || "")),
        email: Yup.string().trim().matches(strictEmailRegex, t("Invalid email")),
        website: Yup.string(),
        messageLanguage: Yup.string().required(t("Message language is required")),
        languages: Yup.array().min(1, t("validation.required")).required(t("validation.required")),
        primaryLanguage: Yup.number().required(t("validation.required")),
        description: Yup.string().max(200, t("Max length is", { number: 200 })),
        currency: Yup.number().required(t("Currency is required")),
        timezone: Yup.number().required(t("Timezone is required")),
    });
};
